import Vue from 'vue';

export const EventBus = new Vue();

export const EventEnums = {
  MERGE_REQUEST_DISCUSSION_CREATED: 'mergeRequest::discussion::created',
  MERGE_REQUEST_DISCUSSION_REPLY_CREATED: 'mergeRequest::discussionReply::created'
};
